import { useCallback, useEffect, useMemo, useState } from "react";

import closeImg from "../../assets/close.webp";

import doddles from "../../assets/doddles.webp";
import { useLeagues } from "../../hooks/useLeagues";
import { formatToMexicoUTC, getDayInMexico } from "../../utils";
import { IoCheckmarkCircle } from "react-icons/io5";
import { IoAddCircleSharp } from "react-icons/io5";
import { FaChevronRight } from "react-icons/fa";

import { Button } from "./button";

const TITLE = ["Selecciona una liga", "Selecciona tus partidos"];

export const CreatePoolWizard = ({ onClose, onAddMatch }) => {
  const [step, setStep] = useState(0);
  const [leagues, setLeagues] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [selectedMatches, setSelectedMatches] = useState([]);

  const { getLeagues, getNextMatches } = useLeagues();

  useEffect(() => {
    const fetchLeagues = async () => {
      const leagues = await getLeagues();
      if (leagues) setLeagues(leagues);
    };

    fetchLeagues();
  }, []);

  const leaguesComponent = useMemo(() => {
    return leagues.map((league) => (
      <section key={league.id} className='flex flex-col'>
        <button
          className='flex'
          onClick={async () => {
            const matches = await getNextMatches(league.id, league.season);
            if (matches) {
              setStep(1);
              setRounds(matches);
            }
          }}>
          <img
            src={league.img}
            width={24}
            alt={league.name}
            className='object-contain'
          />

          <span className='text-white text-[14px] ml-4 my-3'>
            {league.name}
          </span>
          <section className='flex flex-1 items-center justify-end'>
            <FaChevronRight color='white' size={12} />
          </section>
        </button>
        <div className='h-[1px] w-full bg-white opacity-20' />
      </section>
    ));
  }, [leagues, getNextMatches]);

  const existsById = useCallback(
    (id) => selectedMatches.some((item) => item.id === id),
    [selectedMatches],
  );

  const removeById = useCallback(
    (id) => selectedMatches.filter((item) => item.id !== id),
    [selectedMatches],
  );

  const matchesComponent = useMemo(() => {
    return rounds.map((round) => (
      <section key={round.id} className='mb-10'>
        <section className='flex justify-between mb-6'>
          <span className='text-[12px] z-30'>{`Jornada: ${round.round}`}</span>
          <button
            className='text-[9px] text-white opacity-50 underline flex items-center'
            onClick={() => {
              const matches = round.matches.map((match) => {
                return {
                  local: {
                    id: match.home.id,
                    name: match.home.name,
                    logo: match.home.logo,
                  },
                  away: {
                    id: match.visit.id,
                    name: match.visit.name,
                    logo: match.visit.logo,
                  },
                  time: match.utcTime,
                  id: match.id,
                };
              });

              setSelectedMatches(matches);
            }}>
            Agregar todos los partidos
            <IoAddCircleSharp className='ml-1 text-[14px] mt-[2px]' />
          </button>
        </section>
        {round.matches.map((match) => {
          return (
            <section
              key={match.id}
              className='py-2 w-full flex justify-center flex-col'>
              <section className='flex w-full justify-center'>
                <section
                  className='flex flex-col items-center w-full'
                  onClick={() => {
                    if (!existsById(match.id))
                      return setSelectedMatches([
                        ...selectedMatches,
                        {
                          local: {
                            id: match.home.id,
                            name: match.home.name,
                            logo: match.home.logo,
                          },
                          away: {
                            id: match.visit.id,
                            name: match.visit.name,
                            logo: match.visit.logo,
                          },
                          time: match.utcTime,
                          id: match.id,
                        },
                      ]);

                    setSelectedMatches(removeById(match.id));
                  }}>
                  {/* <span className='text-[14px]'>{`${match.home.name} vs ${match.visit.name}`}</span> */}
                  <section className='flex w-full'>
                    <section className='flex flex-1 justify-end items-center'>
                      <span className='text-[11px] mr-2 text-center w-full leading-[14px]'>{`${match.home.name}`}</span>
                      <img
                        src={match.home.logo}
                        alt={match.home.name}
                        width={18}
                        className='object-contain'
                      />
                    </section>
                    <section className='flex items-center'>
                      <span className='text-[14px] mx-4'>VS</span>
                    </section>

                    <section className='flex flex-1 items-center'>
                      <img
                        src={match.visit.logo}
                        alt={match.visit.name}
                        width={18}
                        className='object-contain'
                      />
                      <span className='text-[11px] ml-2 text-center w-full leading-[14px]'>{`${match.visit.name}`}</span>
                    </section>
                  </section>
                  <span className='text-[10px] opacity-80 mt-[8px]'>
                    {getDayInMexico(match.utcTime)}
                    {"  "}
                    {formatToMexicoUTC(match.utcTime)}
                  </span>
                </section>
                <section className='flex items-center w-[18px]'>
                  {existsById(match.id) && (
                    <IoCheckmarkCircle className='text-green-400' />
                  )}
                </section>
              </section>
              <div className='w-full h-[1px] bg-gray-600 mt-3' />
            </section>
          );
        })}
      </section>
    ));
  }, [existsById, rounds, selectedMatches]);

  return (
    <div className='flex justify-center absolute w-[100vw] h-[100dvh] bg-gray-400 z-50 bg-[rgba(6,20,37,0.9)]'>
      <div
        className='absolute w-[90dvw] h-[85vh] z-10 repeat opacity-[0.03] rounded-2xl mt-[4vh]'
        style={{ backgroundImage: `url(${doddles})` }}></div>
      <div className='flex flex-col items-center w-[90vw] h-[85dvh] bg-[rgb(23,43,69)] rounded-2xl p-5 mt-[4vh]'>
        <div className='w-full flex justify-end z-30'>
          <img
            src={closeImg}
            className='z-30'
            alt='close'
            width={14}
            height={14}
            onClick={onClose}
          />
        </div>
        <div className='flex w-full justify-center mt-1'>
          <span className='text-[22px] text-center'>{TITLE[step]}</span>
        </div>
        <section className='mt-4 flex-1  w-full p-3 z-30 overflow-auto'>
          {step === 0 ? leaguesComponent : matchesComponent}
        </section>
        {step === 1 && (
          <section className='h-[10vh] flex items-end z-30'>
            <Button
              label='Agregar'
              disabled={selectedMatches.length === 0}
              onClick={() => {
                selectedMatches.forEach((match) => {
                  onAddMatch(match);
                });
                onClose();
              }}
            />
          </section>
        )}
      </div>
    </div>
  );
};
